export default {
  campaignAvailableSpendGetter(state) {
    return state.campaignAvailableSpend;
  },
};
